/**
 * Created by lzy 19-11-03
 * 百家号渠道已签发
 */
angular.module('editToutiaohaoSignedModule', ['editToutiaohaoSignedRouterModule']).controller('EditToutiaohaoSignedCtrl', [
    '$scope',
    '$state',
    'trsHttpService',
    'modalDialog',
    'toutiaohaoService',
    '$q',
    'trsspliceString',
    'storageListenerService',
    'editingCenterService',
    'editcenterRightsService',
    'editingMediatype',
    'newMediaService',
    'toutConst',
    'messagePublishService',
    '$filter',
    function (
        $scope,
        $state,
        trsHttpService,
        modalDialog,
        toutiaohaoService,
        $q,
        trsspliceString,
        storageListenerService,
        editingCenterService,
        editcenterRightsService,
        editingMediatype,
        newMediaService,
        toutConst,
        messagePublishService,
        $filter
    ) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}
         *   [return description]
         */
        function initStatus() {
            $scope.status = {
                status: 0,
                copyCurrPage: 1,
                mediaType: editingMediatype.toutiaohao,
                status_model: 2,
                isEsSearch: false // 判断是否是经过ES检索之后
            };
            $scope.statusOptions = [
                {
                    name: '全部状态',
                    value: 0,
                },
                {
                    name: '发布中',
                    value: 1,
                },
                {
                    name: '发布成功',
                    value: 2,
                },
                {
                    name: '发布失败',
                    value: 2,
                },
            ];

            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.selectedStatusItem = $scope.statusOptions[0];
            $scope.data = {
                selectedArray: [],
                items: [],
                keyWords: '',
                account: $state.params.account,
                trench: toutConst.listenStroageKey
            };
            $scope.esparams = {}; // es检索参数
            $scope.params = {
                serviceid: 'mlf_toutiao',
                methodName: 'querySigned',
                CHANNELID: $state.params.account,
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE,
                timeType: 0,
                OperTimeStart: $scope.data.fromdate,
                OperTimeEnd: $scope.data.untildate,
                searchKeyWord: '',
                DocType: $scope.data.DocType,
            };
        }

        /**
         * [initData description]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            initDropdown();
            // requestData();
            listenStorage();
            initBtnRights();
            refreshList();
        }

        // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
        $scope.requestData = function() {
            requestData();
        };
        
        /**
         * [initData description]初始化选择类型
         *
         * @return  {[type]}  [return description]
         */
        function initDropdown() {
            $scope.data.docTypeJsons = toutiaohaoService.initSelect();
            $scope.data.selectedDocType = angular.copy($scope.data.docTypeJsons[0]);
            // editingCenterService.dealStorage($scope);
        }

        /**
         * [refreshList description]刷新列表
         * @return  {[undefined]}  [return description]
         */
        function refreshList() {
            messagePublishService.subscribe(
                'refresh',
                function(event, data) {
                    if ((typeof data) === 'object') {
                        $scope.status.isEsSearch = true; // es检索状态
                        $scope.esparams = data;
                    }
                    // 暂时的其他情况是boolean
                    else {
                        $scope.status.isEsSearch = false;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                },
                $scope
            );
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenToutiaohao(function () {
                $scope.status.isEsSearch = false;
                requestData();
                storageListenerService.removeListener('toutiaohao');
            }, $scope);
        }

        /**
         * [requestData description]数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {};
            if ($scope.status.isEsSearch) {
                params = $scope.esparams;
                params.searchParams.PAGEINDEX = $scope.page.CURRPAGE;
            } else {
                params = $scope.params;
                params.CurrPage = $scope.page.CURRPAGE;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                if (!$scope.status.isEsSearch) {
                    $scope.data.keyWords = '';
                }
                $scope.data.items = data.DATA;
                requestListImg(data.DATA).then(function (imgdata) {
                    angular.forEach(data.DATA, function (value, key) {
                        value.ALLIMG = imgdata[value.CHNLDOCID];
                    });
                });
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.data.selectedArray = [];
            });
        }

        /**
         * [getESSearchParams description] 处理ES搜索的参数
         *
         * @return  {[type]}  [return description]
         */
        function getESSearchParams() {
            var esparams = {
                serviceid: 'mlf_hybasesearch',
                methodname: 'queryForNewMediaDoc',
                mediaType: editingMediatype.toutiaohao,
                searchParams: {
                    PAGESIZE: $scope.page.PAGESIZE,
                    PAGEINDEX: $scope.page.CURRPAGE,
                    CHANNELID: $state.params.account,
                    status_model: '2', // ：2表示已签发
                    searchFields: [
                        {
                            searchField: '',
                            keywords: $scope.data.keyWords,
                        },
                        {
                            searchField: 'docType',
                            keywords: $scope.data.DocType || '',
                        },
                        {
                            searchField: 'timeType',
                            keywords:
                                angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== ''
                                    ? $scope.data.fromdate + ',' + $scope.data.untildate
                                    : '',
                        },
                        {
                            searchField: '_sort',
                            keywords: 'time',
                        },
                    ],
                }
            };
            esparams.searchParams = JSON.stringify(esparams.searchParams);
            return esparams;
        }

        /**
         * [requestListImg description]查询列表图示
         *
         * @param   {[type]}  items  [items description]
         *
         * @return  {[type]}         [return description]
         */
        function requestListImg(items) {
            var defer = $q.defer();
            if (!items || items.length < 1) {
                defer.resolve([]);
            } else {
                var params = {
                    serviceid: 'mlf_myrelease',
                    methodname: 'queryAllImgLogo',
                    metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    defer.resolve(data);
                });
            }
            return defer.promise;
        }

        /**
         * [initBtnRights description]初始化百家号操作权限
         *
         * @return  {[type]}  [return description]
         */
        function initBtnRights() {
            editcenterRightsService.initToutiaohaoListBtn('toutiao.yiqianfa', $state.params.account).then(function (rights) {
                $scope.status.btnRights = rights;
            });
        }
        // 按照条件搜索
        $scope.queryByDropdown = function (type, val) {
            if (type === 'DocType') {
                $scope.params.DocType = val;
            } else {
                $scope.params.OperTimeStart = $scope.data.fromdate;
                $scope.params.OperTimeEnd = $scope.data.untildate;
            }
            $scope.page.CURRPAGE = 1;
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };

        /**
         * [fullTextSearch description]搜索
         * @param  {[type]} ev [description]
         * @return {[type]}    [description]
         */
        $scope.fullTextSearch = function (ev) {
            $scope.status.isEsSearch = true;
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };
        // 全选
        $scope.selectAll = function () {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description] 选中的文件
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function (item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [isChecked description] 选中状态
         * @param  {[type]}  item [description]
         * @return {Boolean}      [description]
         */
        $scope.isChecked = function (item) {
            var ischecked = false;
            for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                if ($scope.data.selectedArray[i].CHNLDOCID == item.CHNLDOCID) {
                    ischecked = true;
                    break;
                }
            }
            return ischecked;
        };

        /**
         * [retraction description] 取消签发函数
         * @param  {[type]} ChnlDocIds  [description]
         * @param  {[type]} CHNLDOCIDs [description]
         * @param  {[type]} content     [description]
         * @return {[type]}             [description]
         */
        $scope.retraction = function () {
            if ($scope.data.selectedArray.length > 1) {
                modalDialog.alertType('', '每次最多取消签发一个稿件', 'warning', false);
                return;
            }
            $scope.loadingPromise = newMediaService.retraction($scope, toutConst.retraction);
            // $scope.loadingPromise = newMediaService.retraction(
            //     angular.extend(
            //         {
            //             ChnlDocIds: $scope.data.selectedArray[0].CHNLDOCID,
            //             CHANNELID: $state.params.account,
            //         },
            //         toutConst.retraction
            //     ));
            // modalDialog.inputModel('是否取消签发', '取消签发原因 (选填)', function (content) {
            //     var params = {
            //         serviceid: 'mlf_toutiaooper',
            //         methodname: 'cancelTouTiaoArticles',
            //         ChnlDocIds: $scope.data.selectedArray[0].CHNLDOCID,
            //         CHANNELID: $state.params.account,
            //     };
            //     $scope.status.isSearch = false;
            //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
            //         function (data) {
            //             modalDialog.alertType('取消签发成功', '', 'success', false, function () {
            //                 requestData();
            //             });
            //         },
            //         function (data) {
            //             modalDialog.alertType('取消签发失败', data.message, 'success', 'confirm');
            //         }
            //     );
            // });
        };
        //    重新签发
        $scope.resetSign = function (item) {
            modalDialog.confirmModal('重新签发签发', '确认重新签发?', function () {
                var params = {
                    serviceid: 'mlf_toutiaooper',
                    methodname: 'touTiaoRePublish',
                    METADATAIDS: item.METADATAID,
                    CHANNELID: item.CHANNELID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', true).then(
                    function (data) {
                        modalDialog.alertType('重新签发成功', '', 'success', false, function () {
                            requestData();
                        });
                    },
                    function (data) {
                        modalDialog.alertType('重新签发失败', data.message, 'error', 'confirm');
                    }
                );
            });
        };

        /**
         * [exportDraft description]导出稿件
         *
         * @return  {[type]}  [return description]
         */
        $scope.exportDraft = function () {
            $scope.loadingPromise = newMediaService.export(
                angular.extend(
                    {
                        METADATAIDS: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    },
                    toutConst.export
                ), $scope.data.selectedArray);
            // $scope.status.isSearch = false;
            // var params = {
            //     serviceid: 'mlf_exportword',
            //     methodname: 'exportWordFile',
            //     METADATAIDS: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
            // };
            // $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
            //     function (data) {
            //         window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
            //     },
            //     function (data) {
            //         if (data.REPORTS[0].ISSUCCESS == 'true') {
            //             window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
            //         }
            //     }
            // );
        };

        /**
         * [outSending description]外发
         *
         * @return  {[type]}  [return description]
         */
        $scope.outSending = function () {
            newMediaService.outsource(
                angular.extend(
                    {
                        MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    },
                    toutConst.outsource
                ), $scope.data.selectedArray
            );
        };

        /**
         * [outSendingDraft description]邮件外发
         *
         * @param   {[type]}  items  [items description]
         *
         * @return  {[type]}         [return description]
         */
        // function outSendingDraft(items) {
        //     $scope.status.isSearch = false;
        //     var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
        //     var MetaDataIds = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
        //     var params = {
        //         serviceid: 'mlf_mailoutgoingOper',
        //         methodname: 'touTiaoYiQianFaSendEmail',
        //         Emails: userids,
        //         MetaDataIds: MetaDataIds,
        //     };
        //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
        //         modalDialog.alertType('稿件外发成功！', '', 'success', false, function () {
        //             requestData();
        //         });
        //     });
        // }

        /**
         * [pageChanged description]翻页
         *
         * @return  {[type]}  [return description]
         */
        $scope.pageChanged = function () {
            $scope.loadingPromise = requestData();
        };

        /**
         * [jumpToPage description]跳页
         *
         * @return  {[type]}  [return description]
         */
        $scope.jumpToPage = function () {
            $scope.page.CURRPAGE = angular.copy($scope.status.copyCurrPage);
            $scope.loadingPromise = requestData();
        };

        /**
         * [showVersionTime description]展示流程版本与操作日志
         * @param  {[str]} item [description]
         * @return {[type]}            [description]
         */
        $scope.showVersionTime = function (item) {
            editingCenterService.getVersionTime(item, false);
        };

        /**
         * [distribution description]多元分发
         *
         * @return  {[type]}  [return description]
         */
        $scope.distribution = function() {
            $scope.status.isEsSearch = false;
            if (!editingCenterService.isSameDocType($scope.data.selectedArray, 'DOCTYPEID')){
                modalDialog.alertType('', '多元分发仅支持相同类型的稿件', 'warning', 'confirm', function () { });
                return;
            }
            var temp = $filter('pick')($scope.data.selectedArray, $scope.examDistributionType);
            if (temp.length < 1) {
                editingCenterService.distribution($scope.data.selectedArray, '20', $scope.data.selectedArray[0].DOCTYPEID, 'touTiaoYiQianFaDistribute', function() {
                    $scope.data.selectedArray = [];
                    requestData();
                    // modalDialog.alertType("发稿单修改成功", "", "success", false, function() {
                    // });
                });
            } else {
                modalDialog.alertType('', '多元分发仅支持的稿件类型为新闻、视频', 'warning', 'confirm', function() {});
            }
        };

        /** 多元分发稿件类型  新闻:1、图集:2、链接:4、视频:8、app直播:7
         * [examDistributionType description]
         * @param  {[type]} elm [description]
         * @return {[type]}     [description]
         */
        $scope.examDistributionType = function(elm) {
            if (angular.isDefined(elm)) {
                return elm.DOCTYPEID != 1 && elm.DOCTYPEID != 7;
            }
        };
    },
]);
